export default (theme) => ({
  fieldSet: {
    marginTop: 20,
  },
  radioBtn: {
    margin: '10px 40px 0 0',
    '& .MuiIconButton-root': {
      padding: '0 5px',
    },
  },
  radioLabel: {
    color: theme.palette.font.main,
  },
  activeRadioLabel: {
    color: '#000000',
  },
});
